import RequestsOfBoutiquePackagesContainer from './RequestsOfBoutiquePackagesContainer';
export default RequestsOfBoutiquePackagesContainer;
